import { Link } from "react-router-dom";
import { CalendarDays, MapPin, Pencil, Trash2, ChevronRight } from "lucide-react";
import {
  Card,
  CardHeader,
  CardContent,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";

/** Insère un retour à la ligne avant le code postal (5 chiffres) */
function formatAddress(address: string) {
  const match = address.match(/^(.+?),?\s*(\d{5}.*)$/);
  if (!match) return address;
  return (
    <>
      {match[1]}
      <br />
      {match[2]}
    </>
  );
}

export function SiteCard({
  id,
  name,
  client,
  address,
  zoneCount,
  createdAt,
  onEdit,
  onDelete,
}: {
  id: string;
  name: string;
  client?: string;
  address?: string;
  zoneCount: number;
  createdAt?: Date;
  onEdit: () => void;
  onDelete: () => void;
}) {
  return (
    <Card className="active:scale-[0.98] transition-transform">
      <CardHeader>
        <div className="flex items-start justify-between gap-2">
          <Link to={`/sites/${id}`} className="flex-1 min-w-0">
            <p className="text-base font-semibold leading-tight">{name}</p>
            {client && (
              <p className="mt-0.5 text-sm text-muted-foreground">{client}</p>
            )}
          </Link>
          <div className="flex shrink-0 gap-1">
            <Button
              variant="ghost"
              size="icon-sm"
              className="tap-target rounded-lg ring-1 ring-foreground/8"
              onClick={onEdit}
            >
              <Pencil className="size-4" />
            </Button>
            <Button
              variant="ghost"
              size="icon-sm"
              className="tap-target rounded-lg ring-1 ring-destructive/15 text-destructive hover:bg-destructive/10"
              onClick={onDelete}
            >
              <Trash2 className="size-4" />
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <Link
          to={`/sites/${id}`}
          className="flex flex-col gap-2"
        >
          <div className="flex items-center justify-between gap-2">
            <div className="flex flex-col gap-1 min-w-0">
              {createdAt && (
                <span className="flex items-center gap-1 text-xs text-muted-foreground">
                  <CalendarDays className="size-3 shrink-0" />
                  {new Date(createdAt).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "2-digit" })}
                </span>
              )}
              {address && (
                <span className="flex items-start gap-1 text-xs text-muted-foreground min-w-0">
                  <MapPin className="size-3 shrink-0 mt-0.5" />
                  <span>{formatAddress(address)}</span>
                </span>
              )}
            </div>
            <span className="flex shrink-0 items-center gap-0.5 rounded-full bg-primary/10 px-2.5 py-1 text-xs font-medium text-primary">
              {zoneCount} zone{zoneCount !== 1 ? "s" : ""}
              <ChevronRight className="size-3.5" />
            </span>
          </div>
        </Link>
      </CardContent>
    </Card>
  );
}
